export const UUID_REGEX = /[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}/i;
export const UUID_STRICT_REGEX = new RegExp(`^${UUID_REGEX.source}$`, 'i');

declare const __uuidBrand: unique symbol;
/**
 * Branded string type for UUID values from the core API.
 * Use {@link toUUID} to cast a raw string at system boundaries (mappers, router params).
 */
export type UUID = string & { readonly [__uuidBrand]: void };

/** Cast a raw string to UUID. Use only at system boundaries (mappers, router params, mocks). */
export const toUUID = (s: string): UUID => s as UUID;

export const isUuid = (text: string): boolean => UUID_STRICT_REGEX.test(text);

declare const __userIdBrand: unique symbol;
/**
 * Branded UUID for user identifiers.
 * Assignable to `UUID` and `string` — use wherever a user's id is expected.
 * Use {@link toUserId} to cast at system boundaries (mappers, mocks).
 */
export type UserId = UUID & { readonly [__userIdBrand]: void };

/** Cast a raw string to UserId. Use only at system boundaries (mappers, mocks). */
export const toUserId = (s: string): UserId => s as UserId;
